import axios from "axios";
import config from "../../constants/config";

const BASE_URL = config.API_URL + '/admin/app-version';

export const createAppVersion = async (token, versionData) => {
  return await axios.post(BASE_URL + '/', versionData, {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  });
};

export const updateAppVersion = async (token, id, versionData) => {
  return await axios.put(`${BASE_URL}/${id}`, versionData, {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  });
};

export const getAppVersions = async (token, platform, isActive) => {
  const params = {};
  if (platform && platform !== 'All') params.platform = platform;
  if (isActive !== undefined && isActive !== null && isActive !== '' && isActive !== 'All') params.isActive = isActive;

  return await axios.get(BASE_URL + '/', {
    params,
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  });
};
